import script from "./AppTabsOld.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTabsOld.vue?vue&type=script&setup=true&lang=ts"

import "./AppTabsOld.vue?vue&type=style&index=0&id=1ec6493f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec6493f"]])

export default __exports__